var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// aspect-schemas/StringAspect.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { registerEntity } from "@adornis/baseql/metadata/register.js";
import { html } from "lit";
import { AbstractAspect } from "./AbstractAspect.js";
var escapeRegex = (value) => value.replace(/([^a-zA-Z0-9\s])/g, "\\$1");
var modeDisplay = {
  starts: "Startet mit",
  ends: "Endet mit",
  contains: "Beinhaltet",
  regex: "Matcht",
  equals: "Ist gleich",
  containsOR: "Beinhaltet eins von",
  containsAND: "Beinhaltet alle von",
  containsNONE: "Beinhaltet keines von",
  empty: "Leer"
};
var StringAspect = class extends AbstractAspect {
  constructor(doc) {
    super(doc);
  }
  getMongoFilter() {
    if (!this.fieldName)
      return null;
    if (!Object.keys(modeDisplay).includes(this.mode))
      return null;
    if (this.mode === "empty") {
      return {
        $or: [
          { [this.fieldName]: { $exists: false } },
          { [this.fieldName]: "" },
          { [this.fieldName]: null },
          { [this.fieldName]: { $size: 0 } }
        ]
      };
    }
    if (!this.value)
      return null;
    const regex = escapeRegex(this.value);
    if (this.mode === "contains")
      return { [this.fieldName]: { $regex: regex, $options: "i" } };
    if (this.mode === "containsOR") {
      const orRegex = this.value.split(",").map((s) => escapeRegex(s.trim())).join("|");
      return { [this.fieldName]: { $regex: orRegex, $options: "i" } };
    }
    if (this.mode === "containsAND") {
      const andRegex = this.value.split(",").map((s) => "(?=.*" + escapeRegex(s.trim()) + ")").join("");
      return { [this.fieldName]: { $regex: andRegex, $options: "i" } };
    }
    if (this.mode === "containsNONE") {
      const noneRegex = this.value.split(",").map((s) => escapeRegex(s.trim())).join("|");
      return { [this.fieldName]: { $not: { $regex: noneRegex, $options: "i" } } };
    }
    if (this.mode === "starts")
      return { [this.fieldName]: { $regex: "^" + regex, $options: "i" } };
    if (this.mode === "ends")
      return { [this.fieldName]: { $regex: regex + "$", $options: "i" } };
    if (this.mode === "equals")
      return { [this.fieldName]: this.value };
    try {
      const constructedRegex = new RegExp(this.value, "i");
      return { [this.fieldName]: constructedRegex };
    } catch (error) {
      return null;
    }
  }
};
StringAspect._class = "StringAspect";
__decorateClass([
  Field((type) => String)
], StringAspect.prototype, "value", 2);
__decorateClass([
  Field((type) => String, { default: (v) => v ?? "contains" })
], StringAspect.prototype, "mode", 2);
StringAspect = __decorateClass([
  Entity()
], StringAspect);
var StringAspectConfig = (mode) => {
  if (mode) {
    class StringVariationAspect extends StringAspect {
      constructor(doc) {
        doc.mode = mode;
        super(doc);
      }
    }
    StringVariationAspect._class = `String${mode.toUpperCase()}Aspect`;
    registerEntity(StringVariationAspect);
    const StringModeConfig = {
      aspectConstructor: StringVariationAspect,
      renderEditor: ({ aspectValue }) => html`
          <x-input
            clearable
            placeholder="Text"
            placeholder-mode="hide"
            .value=${aspectValue.value}
            @value-picked=${(e) => aspectValue.value = e.detail.value}
          ></x-input>
        `,
      renderPreview: ({ aspectValue }) => aspectValue.value ? html` ${aspectValue.value} ` : null
    };
    return StringModeConfig;
  } else {
    return {
      aspectConstructor: StringAspect,
      renderEditor: ({ aspectValue }) => html`
        <x-flex horizontal crossaxis-center space="sm">
          <x-input
            .value=${aspectValue.value}
            clearable
            placeholder="Text"
            placeholder-mode="hide"
            @value-changed=${(e) => {
        if (e.detail.value && aspectValue.mode === "regex") {
          try {
            const constructedRegex = new RegExp(e.detail.value, "i");
            e.currentTarget.error = void 0;
          } catch (error) {
            e.currentTarget.error = "Ung\xFCltige Regex";
          }
        } else {
          e.currentTarget.error = void 0;
        }
      }}
            @submit=${(e) => {
        if (aspectValue.mode === "regex") {
          const constructedRegex = new RegExp(e.detail.value, "i");
        }
        aspectValue.value = e.detail.value;
      }}
            @value-picked=${(e) => {
        if (aspectValue.mode === "regex") {
          const constructedRegex = new RegExp(e.detail.value, "i");
        }
        aspectValue.value = e.detail.value;
      }}
          ></x-input>
          <x-button
            mode="icon"
            ?active=${aspectValue.mode === "starts"}
            icon="align_horizontal_left"
            @click=${() => aspectValue.mode = "starts"}
          ></x-button>
          <x-button
            mode="icon"
            ?active=${aspectValue.mode === "contains"}
            icon="align_horizontal_center"
            @click=${() => aspectValue.mode = "contains"}
          ></x-button>
          <x-button
            mode="icon"
            ?active=${aspectValue.mode === "ends"}
            icon="align_horizontal_right"
            @click=${() => aspectValue.mode = "ends"}
          ></x-button>
          <x-button
            mode="icon"
            ?active=${aspectValue.mode === "regex"}
            icon="regular_expression"
            @click=${() => {
        if (aspectValue.value)
          aspectValue.value = escapeRegex(aspectValue.value);
        aspectValue.mode = "regex";
      }}
          ></x-button>
        </x-flex>
      `,
      renderPreview: ({ aspectValue: { mode: mode2, value, fieldName } }) => value ? html` ${modeDisplay[mode2]}: ${value} ` : null
    };
  }
};
var StringVariations = Object.keys(modeDisplay).filter((m) => m !== "empty").map((mode) => {
  return StringAspectConfig(mode);
});
export {
  StringAspect,
  StringAspectConfig,
  StringVariations,
  escapeRegex
};
